import {
  FormattingRuleOperator,
  isRelativeDateValue,
  RelativeDatePeriod,
  RelativeDateUnit,
  type RelativeDateValue,
} from '@ardoq/api-types';
import { getRelativeDateRange, parseDate } from '@ardoq/date-time';
import { getAttributeFormattingValue } from './filterUtils';

export const getRelativeDateValue = (
  isFormattingFilter: boolean,
  filterValue: unknown,
  filterType: string | undefined,
  comparator: string
): RelativeDateValue | null => {
  if (
    comparator === FormattingRuleOperator.RELATIVE_DATE &&
    !isRelativeDateValue(filterValue)
  ) {
    return { period: RelativeDatePeriod.THIS, unit: RelativeDateUnit.WEEK };
  }

  return getAttributeFormattingValue(
    isFormattingFilter,
    filterValue,
    filterType,
    isRelativeDateValue
  );
};

export const isDateInRelativeDateRange = (
  dateValue: unknown,
  relativeDateValue: RelativeDateValue
): boolean => {
  if (typeof dateValue !== 'string' || dateValue.length === 0) return false;
  const dateRange = getRelativeDateRange(relativeDateValue);
  if (!dateRange) return false;
  const date = parseDate(dateValue);
  if (isNaN(date.getTime())) return false;
  return date >= dateRange.start && date <= dateRange.end;
};

export const isDateRangeInRelativeDateRange = (
  startValue: unknown,
  endValue: unknown,
  relativeDateValue: RelativeDateValue
): boolean => {
  if (typeof startValue !== 'string' || startValue.length === 0) return false;
  if (typeof endValue !== 'string' || endValue.length === 0) return false;
  const dateRange = getRelativeDateRange(relativeDateValue);
  if (!dateRange) return false;
  const fieldStart = parseDate(startValue);
  const fieldEnd = parseDate(endValue);
  if (isNaN(fieldStart.getTime()) || isNaN(fieldEnd.getTime())) return false;
  return fieldStart <= dateRange.end && dateRange.start <= fieldEnd;
};
